<template>

  <div class="d-flex justify-content-center w-100" style="margin: 100px 0" v-if="load">
    <Loading />
  </div>
  <div id="bookingForm" v-else class="w-100" >
    <div class="w-100" >
      <fieldset-component texto="Información relevante a la ruta" bold class="mb-3" />

      <div class="px-4">
        <!-- Fila 1 -->
        <div class="d-flex">
          <!-- Año -->
          <ui-select 
            class="w-50" 
            has-search label="Año (*)" 
            placeholder="Seleccionar" 
            :disabled="yearDisabled"
            searchPlaceholder="Buscar" 
            :keys     = "formatSelect" 
            :options  = "yearSelect" 
            v-model="year" 
          />
 
          <!-- Semana -->
          <ui-select 
            class="w-50 ml-3" 
            has-search 
            label="Semana (*)" 
            placeholder="Seleccionar" 
            searchPlaceholder="Buscar"
            :disabled="weekDisabled" 
            :keys="formatSelect" 
            :options="weekSelect" 
            v-model="week" 
          />

          <!-- Empresa -->
          <ui-select 
            class="w-50 ml-3" 
            has-search 
            label="Empresas (*)" 
            placeholder="Seleccionar"
            searchPlaceholder="Buscar" 
            :keys="formatSelect" 
            :options="clientsSelect" 
            v-model="id_client"
            :disabled="id_clientDisabled" 
          />
        </div>

        <!-- Fila 2 -->
        <div class="d-flex mt-3">
          <ui-select 
            class="w-50" 
            has-search 
            label="Puerto de embarque POL (*)" 
            placeholder="Seleccionar"
            v-model="port_load_id" 
            searchPlaceholder="Buscar" 
            :keys="formatSelect" 
            :options="portsSelect" 
            :disabled="port_load_idDisabled" 

          />

          <ui-select 
            class="w-50 ml-3" 
            has-search label="Lugar de origen (*)" 
            placeholder="Seleccionar"
            searchPlaceholder="Buscar" 
            :keys="formatSelect" 
            :options="portsSelect" 
            v-model="port_origin_id" 
          />

          <ui-select 
            class="w-50 ml-3" 
            has-search 
            label="Puerto de descarga - POD (*)" 
            placeholder="Seleccionar"
            searchPlaceholder="Buscar" 
            :keys="formatSelect" 
            v-model="port_discharge_id"
            :options="portsSelect" 
            :disabled="port_discharge_idDisabled" 
          />
        </div>

        <!-- Fila 3 -->
        <div class="d-flex mt-3">
          <ui-select 
            class="w-50" 
            has-search 
            label="Lugar de destino final  (*)" 
            placeholder="Seleccionar"
            searchPlaceholder="Buscar" 
            :keys="formatSelect" 
            :options="portsSelect"
            v-model="port_destination_id" 
          />

          <ui-textbox 
            class="w-50 ml-3" 
            floating-label 
            label="Nave (*)" 
            v-model="vessel" 
            :disabled="vesselDisabled" 
          />

          <ui-textbox 
            class="w-50 ml-3" 
            floating-label 
            label="Viaje (*)" 
            type="text" 
            v-model="voyage" 
            :disabled="voyageDisabled" 
          />
        </div>

        <!-- Fila 4 -->
        <div class="d-flex align-items-center justify-content-between w-100 mt-2">
          <!-- v-if="usuarioActual.id_country != 64" -->
          <div class="d-flex align-items-center justify-content-between w-100">
            <ui-switch v-model="showTransporteTerrestre">
              ¿Transporte terrestre?
            </ui-switch>

            <Button 
              v-if="bookingItineraryId !== null"
              :size="17" 
              :width="170" 
              :height="30" 
              text="Seleccionar Nave y Viaje" 
              color="#0174f3"
              colorText="#ffffff" 
              icon="fas fa-ship" 
              tooltip="Seleccionar Nave y Viaje" 
              horizontal
              @click.native="showServices" 
            />
            <Button 
              v-else
              :size="17" 
              :width="170" 
              :height="30" 
              text="Seleccionar Nave y Viaje" 
              color="#0174f3"
              colorText="#ffffff" 
              icon="fas fa-ship" 
              tooltip="Seleccionar Nave y Viaje" 
              horizontal
              @click.native="actionSetVisibleModalSeleccionNaveActualizar(true)" 
            />
          </div>

          <seleccion-nave-modal-update 
            :year="year" 
            :week="week"
            :pod="port_discharge_id" 
            :type="id_container_type" 
          />
        </div>
      </div>
    </div>

    
    <div class="mt-4">
      <fieldset-component texto="Información de camionaje" bold class="mb-3" />

      <div class="w-100">
        <!-- Fila -->
        <div class="d-flex px-4">
          <ui-textbox
            class="w-50"
            floating-label
            label="Tipo movimiento"
            disabled
            v-model="haulage_movement_type"
          />
          <ui-textbox
            class="w-50 ml-3"
            floating-label
            label="Costo camionaje"
            disabled
            v-model="haulage_cost"
          />
          <ui-textbox
            class="w-50 ml-3"
            floating-label
            label="Tipo de Transporte"
            disabled
            v-model="haulage_transport_type"
          />
        </div>

        <div
          class="d-flex px-4"
          v-if="showTransporteTerrestre "
        >
          <ui-select
            class="w-50"
            has-search
            label="Lugar de carga"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            :options="portsSelect"
            v-model="haulage_port_origin_id"
          />

          <div class="d-flex flex-column w-50 px-3">

            <label class="content-datepicker m-0 color-primary">Fecha retiro unidad</label>
            <date-picker
              format="YYYY-MM-DD"
              type="date"
              v-model="haulage_withdrawal_date"
            />

          </div>

          <ui-select
            class="w-50 ml-3"
            has-search
            label="Tipo chasis (*)"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            :options="[]"
            v-model="haulage_rampla"
          />
        </div>

        <!-- Fila 3 -->
        <div
          class="d-flex px-4"
          v-if="showTransporteTerrestre"
        >
          <ui-select
            class="w-50"
            has-search
            label="Packing"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="formatSelect"
            :options="[]"
            v-model="haulage_packing_id"
          />

          <ui-textbox
            class="w-50 ml-3"
            floating-label
            label="Dirección packing"
            v-model="haulage_carrier"
            disabled
          />

        </div>
      </div>
    </div>
    <div class="w-100" v-if="showModuleServicioIntegral">
      <fieldset-component
        texto="Información de Servicio Integral"
        bold
        class="mb-3 mt-4"
      />

      <div class="d-flex px-4">
        <ui-select
          class="w-50"
          has-search
          label="¿Servicio Integral? (*)"
          placeholder="Seleccionar"
          searchPlaceholder="Buscar"
          :options="optionsBase"
          :keys="formatSelect"
          v-model="has_si"
        />

        <ui-select
          v-if="has_si.id"
          class="w-50 ml-3"
          has-search
          label="Tipo Servicio Integral (*)"
          placeholder="Seleccionar"
          searchPlaceholder="Buscar"
          :keys="formatSelect"
          :options="servicioIntergralSelect"
          v-model="si_type_id"
        />
      </div>
    </div>
    <div class="w-100">
      <fieldset-component
        texto="Información relevante a shipper"
        bold
        class="mb-3 mt-4"
      />

      <div class="px-4">
        <div class="d-flex my-2">
          <ui-select
            class="w-50"
            has-search
            label="Shipper (*)"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="formatSelect"
            :options="shipperSelect"
            v-model="shipper"
            @change="
              setSelectAndOptionsEmbarcador(true);
              obtenerDireccionesPorShipper();
              obtenerConsignatariosYNotificadosData();
            "
          />

          <ui-select
            class="w-50 ml-3"
            has-search
            label="Dirección shipper (*)"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="formatSelect"
            v-model="shipper_address_id"
            :options="shipperAddressSelect"
          />

          <ui-select
            class="w-50 ml-3"
            has-search
            label="Consignatario"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="formatSelect"
            :options="shipperConsigneeSelect"
            v-model="shipper_consignee_id"
          />
        </div>

        <div class="d-flex my-2">
          <ui-select
            class="w-50"
            has-search
            label="Notificado"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            ref="selectListarNotificados"
            :keys="formatSelect"
            v-model="shipper_notify_id"
            :options="shipperNotifySelect"
          />
          
          <ui-select
            class="w-50 ml-3"
            has-search
            label="Embarcador"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="formatSelect"
            :options="embarcadorSelect"
            v-model="shipper_id"
          />
        </div>
      </div>
    </div>

    <div class="w-100">
      <fieldset-component
        texto="Información relevante a la carga"
        bold
        class="mb-3 mt-4"
      />

      <div class="px-4">
        <!-- Fila 1 -->
        <div class="d-flex">
          <ui-select
            class="w-50"
            has-search
            label="Contenedor a solicitar (*)"
            placeholder="Seleccionar"
            v-model="container_id"
            searchPlaceholder="Buscar"
            :keys="formatSelect"
            :options="containerSelect"
            @change = "
              isReeferValidate() ;
              obtenerContratos() ;
              changeReeferParameters() ;
            "
          />
          <ui-select
            class="w-50 ml-3"
            has-search
            label="Producto a exportar (*)"
            placeholder="Seleccionar"
            v-model="id_client_product"
            searchPlaceholder="Buscar"
            :keys="formatSelect"
            :options="productsClientSelect"
            @change = "obtenerContratos(); obtenerRefigeracionProductoSeleccionado();"
          />



          <ui-textbox
            v-if="bookingItineraryStateId == 2"
            v-model="cant"
            class="w-50 ml-3"
            floating-label
            label="Cant. de contenedores (*)"
            type="number"
            error="Este campo es obligatorio."
          />

          <ui-textbox
            v-else-if="bookingItineraryStateId == 5"
            v-model="embarked_containers"
            class="w-50 ml-3"
            floating-label
            label="Cantidad de contenedores Embarcados (*)"
            type="number"
            error="Este campo es obligatorio."
          />

          <ui-textbox
            v-else-if="bookingItineraryStateId === null"
            v-model="containers_requested"
            class="w-50 ml-3"
            floating-label
            label="Cantidad de contenedores a solicitar (*)"
            type="number"
            error="Este campo es obligatorio."
          />

        </div>

        <!-- Fila 2 -->
        <div class="d-flex" v-if="isReefer">
          <ui-textbox
            class="w-50"
            floating-label
            label="Temperatura °C (*)"
            @blur="clearCharactersTemperature()"
            v-model="container_temperature"
          />

          <ui-textbox
            v-model="container_percent_ventilation"
            class="w-50 ml-3"
            floating-label
            type="number"
            label="% Ventilación (*)"
          />

          <ui-textbox
            v-model="container_cbm_ventilation"
            class="w-50 ml-3"
            floating-label
            label="Ventilación CBM (*)"
            type="number"
          />

          <ui-select
            class="w-50 ml-3"
            v-model="container_cold_treatment"
            has-search
            label="Con Cold Treatment (*)"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="formatSelect"
            :options="optionsBase"
          />
        </div>

        <!-- Fila 3 -->
        <div class="d-flex" v-if="isAtmosphera">
          <ui-select
            class="w-50"
            has-search
            label="Atmósfera controlada (*)"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="formatSelect"
            :options="atmosferasSelect"
            v-model="container_atmosphere_id"
          />

          <ui-textbox
            class="w-50 ml-3"
            floating-label
            label="% Oxígeno (O2) (*)"
            type="number"
            v-model="container_percent_o2"
          />

          <ui-textbox
            class="w-50 ml-3"
            floating-label
            label="% CO2 (*)"
            type="number"
            v-model="container_percent_co2"
          />

          <div class="w-50 ml-3"></div>
        </div>

        <div class="d-flex" v-if="bookingItineraryId !== null">
          
          <ui-textbox
            class="w-50 "
            floating-label
            label="Nro Booking"
            v-model="booking_number"
          />

          <ui-textbox
            class="w-50 ml-3"
            floating-label
            label="Nro Carrier Booking"
            v-model="carrier_booking_number"
          />

        </div>

        <div class="d-flex" v-if="bookingItineraryId !== null">
          
          <ui-select
            class="w-50 "
            v-model="deposit_id"
            has-search
            label="Depósito"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar Deposito"
            :keys="formatSelect"
            :options="depositsSelect"
          />

          <ui-select
            class="w-50 ml-3"
            v-model="port_track_id"
            has-search
            label="Vía"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar Vía"
            :keys="formatSelect"
            :options="portsSelect"
          />
          
          <ui-select
            class="w-50 ml-3"
            v-model="id_naviera_salida"
            has-search
            label="Naviera de Salida"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar Naviera"
            :keys="formatSelect"
            :options="navieras"
          />

        </div>
        
      </div>
    </div>

    <div class="w-100">
      <fieldset-component
        texto="Información adicional"
        bold
        class="mb-3 mt-4"
      />

      <div class="px-4">

        <!-- Fila 1 -->
        <div class="d-flex">
          <ui-select
            class="w-50"
            has-search
            label="Forma de pago (*)"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="formatSelect"
            v-model="payment_method"
            :options="paymentMethodSelect"
            error="Este campo es obligatorio."
          />

          <ui-select
            class="w-50 ml-3"
            has-search
            label="Uso de genset de la naviera"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="formatSelect"
            v-model="genset"
            :options="optionsBase"
          />
          
          <!-- <ui-select v-if="bookingItineraryId !== null"
              class="w-50 ml-3"
              has-search
              label="Oficina Comercial"
              placeholder="Seleccionar"
              searchPlaceholder="Buscar"
              :keys="formatSelect"
              v-model="commercialOffice"
              :options="optionsCommercialOffice"
            /> -->

        </div>

        
        <!-- Fila 2 -->
        <div class="d-flex">

          <ui-select v-if="bookingItineraryId !== null"
            class="w-50 "
            has-search
            label="Filial Ejecutora (*)"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="formatSelect"
            v-model="filialEjecutora"
            :options="optionsCommercialOffice"
            />
        
          <ui-select v-if="bookingItineraryId !== null"
              class="w-50 ml-3"
              has-search
              label="Filial Originadora (*)"
              placeholder="Seleccionar"
              searchPlaceholder="Buscar"
              :keys="formatSelect"
              v-model="filialOriginadora"
              :options="optionsCommercialOffice"
              />
        
          <ui-select 
            v-if="bookingItineraryId !== null"
            class="w-50 ml-3"
            has-search
            label="Filial de soporte"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="formatSelect"
            v-model="filialSoporte"
            :options="optionsCommercialOfficeWithDefault"
            />

        </div>

        <!-- Fila 3 -->
        <div class="d-flex">
          <ui-textbox
            class="w-50"
            floating-label
            label="Emisión de BL (*)"
            v-model="emition_bl"
          />

        <!-- xx -->
          <ui-select
            class="w-50 ml-3"
            has-search
            label="Contrato (*)"
            v-model="tariff_contract_id"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :options="tariffContractSelect"
            :keys="formatSelect"
          />
        </div>

        <!-- Fila 2.1 -->
        <div class="d-flex">
          <ui-textbox
            class="w-100"
            floating-label
            label="Nro. Contrato (*)"
            v-model="contract"
            v-if="tariff_contract_id.id === null"
            title="Nro. de Contrato ingresado se utilizará en la generación de los respectivos bs/l. UCC no será responsable por el mal ingreso de ésta información."
          />
        </div>

        <!-- Fila 3 -->
        <div class="d-flex">
          <ui-textbox
            class="w-100"
            v-model="comment"
            floating-label
            label="Comentarios"
            multiLine
            style="min-height: 115px !important"
            :rows="5"
            :maxlength="256"
          />
        </div>
      </div>
    </div>

    <div class="d-flex float-right mt-2 py-3">

      <Button
        horizontal
        text  = "Actualizar"
        style = "margin-bottom: 0px !important"
        color = "#21831b"
        colorText = "#fff"
        icon  = "far fa-paper-plane"
        title = "Actualizar Reserva"
        :inactive     = "btnInactive"
        :active       = "btnInactive"
        @click.native = "!btnInactive && actualizar()"
      />
    </div>

    <cambiar-servicio-booking-confirmado-modal 
      :form="form"
      :load="loadingChangeService"
    /> 
  </div>

  
</template>


<script>

import { mapActions, mapState } from "vuex";

import UiTextbox from "keen-ui/lib/UiTextbox";
import UiSwitch from "keen-ui/lib/UiSwitch";
import UiSelect from "keen-ui/lib/UiSelect";
import SeleccionNaveModalUpdate from "../../modals/lineas/booking/SeleccionNaveModalUpdate";
import Button from "../../../components/common/Button";
import FieldsetComponent from "../../../components/common/FieldsetComponent";
import DatePicker from "vue2-datepicker";
import CambiarServicioBookingConfirmadoModal from "../../modals/lineas/booking/bookings_confirmados/CambiarServicioBookingConfirmadoModal";

import {
  getBookingsNoPlanificadosSinLoading,
  verBooking,
  obtenerShippers,
  obtenerDireccionesPorShipper,
  getSelectAndOptionsEmbarcador,
  obtenerConsignatariosYNotificados,
  obtenerProductosPorCliente,
  obtenerBranches,
  obtenerContrato,
  editarBooking,
  getBookingsDeclarados,
  getVerMisBookingsPorAceptar,
  verBookingItineraries,
  getBookingsConfirmadosCliente,
  getBookingsEmbarcados,
  getBookingsSolicitudesModificacion,
  getBookingsConfirmadosClienteFiltrados,
  getBookingsEmbarcadosFiltrados,
  getVerMisBookingsPorAceptarFiltrados, getBookingsDeclaradosFiltrados, getBookingsSolicitudesModificacionFiltradas,
  obtenerRefigeracionProducto
} from "../../../constants/lineas";

import Loading from "../loading.vue";

export default {
  components: {
    UiTextbox,
    UiSwitch,
    UiSelect,
    SeleccionNaveModalUpdate,
    Button,
    FieldsetComponent,
    DatePicker,
    Loading,
    CambiarServicioBookingConfirmadoModal
  },
  props: {
    idBooking  : { type: Number, default: 0 },
    closeModal : { type: Function , default: () => {} },
    showModuleServicioIntegral : { type: Boolean, default: true },
    mode : { type: String, default: "EDICION" },
  },
  data() {
    return {
      // FORM INIT
        year: {},
        week: {},
        id_client: {},
        port_load_id: {},
        port_origin_id: {},
        port_discharge_id: {},
        port_destination_id: {},
        vessel: '',
        voyage: '',
        // Información de camionaje
        haulage_movement_type   : '',
        haulage_cost            : '',
        haulage_transport_type  : '',
        haulage_port_origin_id  : {},
        haulage_withdrawal_date : '',
        haulage_rampla          : {} ,
        haulage_packing_id      : {} ,
        haulage_carrier         : '' ,
        // Información de Servicio Integral
        has_si: { id: false , name :'NO' },
        si_type_id: {},

        //Información relevante a shipper
        shipper: {},
        shipper_address_id: {},
        shipper_consignee_id: {},
        shipper_notify_id: {},
        shipper_id: {},
        // Información relevante a la carga
        container_id: {},
        id_client_product: {},
        commercialOffice: {},
        containers_requested: "",
        cant: "",
        embarked_containers: null,
        // Is reefer
        container_temperature: null,
        container_percent_ventilation: null,
        container_cbm_ventilation: null,
        container_cold_treatment: {},
        // Is Atmosp
        container_atmosphere_id: {},
        container_percent_o2: null,
        container_percent_co2: null,
        booking_number : "" ,
        carrier_booking_number : "",
        deposit_id : {},
        port_track_id : {},
        id_naviera_salida : {},
        itinerary_id : null,
        // Información adicional
        payment_method: {},
        genset: {},
        emition_bl: null,
        filialEjecutora: null,
        filialOriginadora: null,
        filialSoporte: null,
        tariff_contract_id: {
          id   : null ,
          name : 'Otro'
        },
        contract: "",
        comment: "",
      // FORM END
      yearDisabled: false,
      weekDisabled: false,
      id_clientDisabled: false,
      port_load_idDisabled: false,
      port_discharge_idDisabled: false,
      vesselDisabled: false,
      voyageDisabled: false,

      showTransporteTerrestre: false,

      booking: null,

      formatSelect : { value: 'id', label: 'name' } ,

      isReefer : false ,
      isAtmosphera : false ,
      optionsBase: [
        { id: "", name: "SIN ESPECIFICAR"},
        { id: 1 , name : 'SI' } ,
        { id: 0 , name : 'NO' }
      ],

      //FILTROS
      yearSelect    : [],
      weekSelect    : [] ,
      clientsSelect : [] ,
      portsSelect   : [] ,
      shipperSelect : [] ,
      shipperAddressSelect    : [] ,
      shipperConsigneeSelect  : [] ,
      shipperNotifySelect     : [] ,
      embarcadorSelect        : [] ,
      servicioIntergralSelect : [] ,
      tipoChasisSelect: [
        { id: 1, name: "Normal" },
        { id: 2, name: "3 Ejes" },
      ],
      containerSelect : [] ,
      containerSelectAll : [] ,
      productsClientSelect : [] ,
      optionsCommercialOffice : [] ,
      atmosferasSelect: [] ,
      paymentMethodSelect : [] ,
      tariffContractSelect : [{
        id   : null ,
        name : 'Otro'
      }] ,
      depositsSelect : [] ,
      //
      load: false,
      btnInactive : false , 
      //valores para obtener contratos
      navieraId : null ,
      polEtd    : null ,
      fieldBlockByItinerary : true,
      bookingItineraryId : null ,
      bookingId : null ,
      bookingItineraryStateId : null ,
      loadingChangeService : false ,
      form: null,
      tariffsData: [],
      id_container_type : null,
      containerSelected: []
    }
  },
  computed: {
    
    optionsCommercialOfficeWithDefault() {
      return [
        { id: null, name: "Seleccionar",  },
        ...this.optionsCommercialOffice
      ];
    },

    
    ...mapState(["navieras" , "puertos", "usuarioActual"]),

    ...mapState("lineas", [
      "dataNaveSeleccionada",
      'stateIdDeclarados',
      'idBookingItinerary',
      'infoSolicitudModificacion',
      "flagFiltersBookings",
      "currentFiltersBookings"
    ]),
  },
  methods: {

    ...mapActions("lineas", [
      "actionSetVisibleModalSeleccionNaveActualizar",
      "actionSetDataDatatableBookingsDeclarados",
      "actionSetStateIdDeclarados",
      "actionSetDatatableVerMisBookingsPorAceptar",
      "actionSetVisibleModalCambiarServicioConfirmadoBooking",
      "actionSetDatatableBookingsConfirmados",
      "actionSetDataDatatableBookingsEmbarcados",
      "actionSetDatatableBookingsSolicitudesModificacion",
      "actionSetVisibleModalInformacionGeneral"
    ]),
    
    async getBooking( idBooking ){
      
      return await verBooking( idBooking ) ;
    },
    async getBookingItinerary( idBookingItinerary ){
      const form = { booking_itinerary_id : idBookingItinerary } ;
      return await verBookingItineraries( form ) ;
    },
    async setData( data ){

      this.bookingId = +data.id_booking ;

      this.year = {
        id   : data.anio.toString() ,
        name : data.anio.toString() 
      } ;

      this.week = {
        id   : data.semana.toString() ,
        name : data.semana.toString() 
      } ;

      this.id_client = {
        id   : +data.id_cliente ,
        name : data.cliente 
      } ;

      this.port_load_id = {
        id   : data.id_pol.toString() ,
        name : data.pol 
      }; 

      this.port_origin_id = {
        id   : data.id_puerto_origen.toString() ,
        name : data.puerto_origen 
      }; 

      this.port_discharge_id = {
        id   : data.id_pod.toString() ,
        name : data.pod 
      }; 

      this.port_destination_id = {
        id   : data.id_destino_final.toString() ,
        name : data.destino_final 
      }; 

      this.vessel = data.nave ;
      this.voyage = data.viaje ;

      this.haulage_movement_type = data.tipo_movimiento ;

      this.haulage_cost = data.costo_camionaje ;

      this.shipper = {
        id   : +data.id_shipper ,
        name : data.shipper
      } ;

      this.shipper_address_id = {
        id   : +data.shipper_address_id ,
        name : data.shipper_address
      } ;

      this.has_si = {
        id   : ( data.has_si == 1 ) ,
        name : data.has_si == 1 ? 'SI' : 'NO'  
      } ;

      if( data.notify ){
        this.shipper_notify_id = {
          id   : +data.id_notify,
          name : data.notify
        } ; 
      }

      this.shipper_id = {
        id   : +data.shipper_id ,
        name : data.shipper_name
      } ;

      if( data.consignee ){

        this.shipper_consignee_id = {
          id   : +data.id_consignee,
          name : data.consignee
        } ; 
      }
      else {
        this.shipper_consignee_id = {};
      }

      this.container_id = {
        id   : data.id_equipo ,
        name : data.equipo
      } ;

      this.id_client_product = {
        id   : +data.id_producto ,
        name : data.producto ,
        id_product_type : +data.id_product_type
      } ;

      this.containers_requested = data.containers_requested ;
      this.container_temperature = data.temperatura ;

      this.container_percent_ventilation = data.ventilacion ;
      this.container_cbm_ventilation     = data.ventilacion_cbm ;

      if( data._container_cold_treatment !== null ){

        this.container_cold_treatment = {
          id :  data.is_cold_treatment,
          name : data.is_cold_treatment == 1 ? 'SI' : 'NO'
        } ;

      }
      else {

        this.container_cold_treatment = {
            id: "",
            name: "SIN ESPECIFICAR"
        };

      }
      
      if( data.container_atmosphere_id ){

        this.container_atmosphere_id = {
          id :  +data.container_atmosphere_id ,
          name : data.atmosfera
        } ;

      } else {
        this.container_atmosphere_id = {} ;
      }

      this.container_percent_o2  = data.ventilacion_o2 ;
      this.container_percent_co2 = data.ventilacion_co2 ;
      
      this.payment_method = {
        id : +data.forma_pago_flete ,
        name : data.payment_method_name
      } ;

      if (data._genset !== null) {

        this.genset = {
          id: data._genset,
          name: data._genset === 1 ? "SI" : "NO"
        };

      } else {

        this.genset ={
          id: "",
          name: "SIN ESPECIFICAR"
      };

      }


      this.emition_bl = data.emision_bl ;
      this.filialEjecutora = {
        id : +data.id_filial_ejecutora ,
        name : data.filial_ejecutora
      } ;
      this.filialOriginadora = {
        id : +data.id_filial_originadora ,
        name : data.filial_originadora
      } ;
      this.filialSoporte = {
        id : +data.id_filial_soporte ,
        name : data.filial_soporte
      } ;
      
      this.contract = data.contrato_booking ;

      if( data.tariff_contract_id ){
        this.tariff_contract_id = {
          id   : +data.tariff_contract_id ,
          name : data.contrato
        } ;
      }
      else {
        this.tariff_contract_id = {
          id   : null ,
          name : 'Otro'
        } ;
      }

      this.navieraId = +data.naviera_id ;
      this.polEtd = data.pol_etd ;

      this.comment = data.comentarios ;

      this.id_container_type = data.id_container_type ;

      this.commercialOffice = data.commercial_office_id;
    },
    async setDataBooking( idBooking ){
      
      const booking = await this.getBooking( idBooking ) ;

      this.setData( booking );

      this.itinerary_id = +booking.itinerary_id ;
      if( booking.has_si == 1 ) {
        
        this.si_type_id = {
          id   : +booking.si_type_id,
          name : booking.servicio_integral
        } ; 
      }
     
      this.selectsByClient() ;
      this.disabledField() ;
    },
    async setDataBookingItinerary( idBooking ){

      
      const bookingItinerary = await this.getBookingItinerary( idBooking ) ;
      
      this.setData( bookingItinerary );

      this.bookingItineraryId = +bookingItinerary.booking_itinerary_id ;

      this.bookingItineraryStateId = +bookingItinerary.booking_itinerary_state_id ;

      this.cant = +bookingItinerary.cantidad_bi;

      this.embarked_containers = bookingItinerary.embarked_containers;

      this.booking_number = bookingItinerary.booking_number ;
      this.carrier_booking_number = bookingItinerary.carrier_booking_number ;

      this.deposit_id = {
        id   : bookingItinerary.id_deposito,
        name : bookingItinerary.deposito
      } ;

      if( bookingItinerary.id_via ){
        this.port_track_id = {
          id   : bookingItinerary.id_via.toString(),
          name : bookingItinerary.via
        } ;
      }
      
      if( bookingItinerary.id_naviera_salida ){
        this.id_naviera_salida = {
          id   : bookingItinerary.id_naviera_salida.toString() ,
          name : bookingItinerary.naviera_salida
        } ;
      } else {
        this.id_naviera_salida = {};
      }
      

      if( bookingItinerary.has_si == 1 ) {
        this.si_type_id = {
          id   : +bookingItinerary.si_type_id,
          name : bookingItinerary.servicio_integral_type
        } ; 
      }

      if ( bookingItinerary.id_filial ) {
        this.commercialOffice = {
          id   : +bookingItinerary.id_filial,
          name : bookingItinerary.nombre_filial
        }
        
      }


      // if( !bookingItinerary.id_filial ){
      //   this.commercialOffice = {
      //     id   : +this.usuarioActual.id_filial,
      //     name : this.usuarioActual.filial
      //   }
      // }else{
      //   this.commercialOffice = {
      //     id   : +bookingItinerary.id_filial,
      //     name : bookingItinerary.nombre_filial
      //   }

      // }

      this.selectsByClient() ;
      this.disabledField() ;
    },
    // Función para listar selects asociados al cliente
    async selectsByClient(){ 
      this.obtenerBranches();
      this.changeShipper() ;
      this.obtenerDireccionesPorShipper() ;
      this.obtenerConsignatariosYNotificadosData() ;
      this.obtenerProductosPorCliente() ;
      this.isReeferValidate() ;
      this.obtenerContratos() ;
    },
    async obtenerProductosPorCliente() {
        this.productsClientSelect = await obtenerProductosPorCliente( this.id_client.id );
      },
    async obtenerBranches() {
      this.optionsCommercialOffice = await obtenerBranches();
    },
    async changeShipper( ) {
      if( this.id_client.id ){
        this.shipperSelect = await obtenerShippers( this.id_client.id );
      }
    },
    async obtenerContratos(){
        
      if (
        this.port_load_id.id && this.port_destination_id.id  &&
        this.id_client_product.id_product_type && this.container_id.id  
      ){
        const form = {
          pol                   : +this.port_load_id.id,
          pod                   : +this.port_destination_id.id,
          naviera_id            : this.navieraId,
          products_category_id  : +this.id_client_product.id_product_type ,
          container_id          : this.container_id.id ,
          client_id             : +this.id_client.id,
          atmosphere_id         : this.container_atmosphere_id.id ?? null ,
          from_date             : this.polEtd
        };

        const sql = await obtenerContrato( form );
        const selectBase = { id  : null , name : 'Otro' } ;
        let dataSelectContratos = [];

        if (sql.length > 0) {

          this.tariffsData = sql ;
          dataSelectContratos = sql.map( c => ({ id: c.tariff_contract_id , name: c.contrato } ) ) ;
         
        } else {
          this.tariff_contract_id = selectBase ;
          this.$vToastify.warning("Esta ruta no posee contrato, por favor contacte al administrador o ingrese su propio número de contrato.","!Precaución¡");
        } 

        dataSelectContratos.push( selectBase ) ;

        this.tariffContractSelect = dataSelectContratos ;
      }
    },
    async obtenerDireccionesPorShipper( ) {
      if( this.shipper.id ){
        this.shipperAddressSelect = await obtenerDireccionesPorShipper( this.shipper.id ) ;
      }
    },
    async setSelectAndOptionsEmbarcador( clear = false ){

      if( this.shipper.id ){
        const { data } = await getSelectAndOptionsEmbarcador( this.shipper.id ) ;
        
        if( data.options !== null ) this.shipper_id = data.options ;

        if( clear ){
          this.shipper_address_id   = {} ;
          this.shipper_consignee_id = {} ;
          this.shipper_notify_id    = {} ;
        }
      }
    },
    async obtenerConsignatariosYNotificadosData( clear = false ) {

      const { data } = await obtenerConsignatariosYNotificados( this.shipper.id );

      const { consignatarios, notificados } = data;
      this.shipperConsigneeSelect = consignatarios ? consignatarios.map( c => ({
        id : c.id,
        name : c.name
      })) : [] ; 
        
      this.shipperNotifySelect = notificados ? notificados.map( n => ({
        id : n.id,
        name : n.name
      })) : [] ;

      if (clear) {
        this.shipper_notify_id    = {} ;
        this.shipper_consignee_id = {} ;
        this.shipper_address_id   = {} ;
      }
    },
    informacionDeRuta() {
      if (
        !this.port_load_id.id || !this.port_origin_id.id ||
        !this.port_discharge_id.id ||
        !this.port_destination_id.id
      ) {
        return;
      }

      // cost y type sólo varian cuando el movementType = CY/CY, por lo cual se dejan
      // setteados con opciones por defectos para los casos restantes.
      this.haulage_cost = "Naviera";
      this.haulage_transport_type = "CH Carrier Haulage";

      // CY/CY
      if (
        this.port_origin_id.name ==
          this.port_load_id.name &&
        this.port_discharge_id.name ==
          this.port_destination_id.name
      ) {
        // Información guardada en modelos
        this.haulage_movement_type = "CY/CY";
        this.haulage_cost = "Cliente";
        this.haulage_transport_type = "MH Mercahnt Haulage";
      } else if (
        // Door to Port
        this.port_origin_id.name != this.port_load_id.name &&
        this.port_discharge_id.name == this.port_destination_id.name
      ) {
        // Información guardada en modelos
        this.haulage_movement_type = "Door to Port";
      } else if (
        // Port To Door
        this.port_origin_id.name ==
          this.port_load_id.name &&
        this.port_discharge_id.name !=
          this.port_destination_id.name
      ) {
        // Información guardada en modelos
        this.haulage_movement_type = "Port To Door";
      } else if (
        // Door To Door
        this.port_origin_id.name !=
          this.port_load_id.name &&
        this.port_discharge_id.name !=
          this.port_destination_id.name
      ) {
        // Información guardada en modelos
        this.haulage_movement_type = "Door To Door";
      }
    },
    async filtrosBase(){

      const { 
        filtroAnios, 
        clients,
        filtroMetodosPago ,
        filtroSemanas,
        filtro_contenedores ,
        filtro_puertos ,
        listaAtmosferas ,
        listaServiciosIntegrales ,
        shippers ,
        deposits
      } = await getBookingsNoPlanificadosSinLoading() ;

      this.yearSelect             = filtroAnios ;
      this.weekSelect             = filtroSemanas ;
      this.clientsSelect          = clients  ;
      this.portsSelect            = filtro_puertos  ;
      this.servicioIntergralSelect = listaServiciosIntegrales ;
      this.depositsSelect          = deposits ;
      this.containerSelect         = filtro_contenedores.map( c => ({
        id : c.id,
        name : c.name
      })) ;
      this.containerSelectAll     = filtro_contenedores ;
      this.atmosferasSelect       = listaAtmosferas ;
      this.paymentMethodSelect    = filtroMetodosPago ;
      this.embarcadorSelect       = shippers ;
    },
    changeReeferParameters() {

      if ( this.containerSelected.with_ac == 0 && this.containerSelected.with_frozen == 0 ) {

        this.container_temperature          = null;
        this.container_percent_ventilation  = null;
        this.container_cbm_ventilation      = null;
        this.container_cold_treatment.id    = null;
        this.container_atmosphere_id.id     = null;
        this.container_percent_o2           = null;
        this.container_percent_co2          = null;
      }

      if ( this.containerSelected.with_ac == 0 && this.containerSelected.with_frozen == 1 ) {

        this.container_atmosphere_id.id     = null;
        this.container_percent_o2           = null;
        this.container_percent_co2          = null;
        
      }
      
    },
    isReeferValidate() {
      
      let container = {} ;
      
      this.containerSelectAll.forEach( c => {
        if( this.container_id.id == c.id ) container = c ;
      }) ;

      this.containerSelected = container;

      this.isAtmosphera = container.with_ac == 1 ;
      this.isReefer = container.with_frozen == 1 ;
    },
    validar() {

      if ( !this.vessel ) {
        this.$vToastify.error("Campo requerido", "Error: Nave");
        return false ; 
      }

      if ( !this.voyage ) {
        this.$vToastify.error("Campo requerido", "Error: Viaje");
        return false ; 
      }

      if( this.isReefer ){
        
        if ( !this.container_temperature ) {
          this.$vToastify.error("Campo requerido", "Error: Temperatura °C");
          return false ; 
        }

        if ( !this.container_percent_ventilation ) {
          this.$vToastify.error("Campo requerido", "Error: % Ventilación");
          return false ; 
        }

        if ( !this.container_cbm_ventilation ) {
          this.$vToastify.error("Campo requerido", "Error: Ventilación CBM");
          return false ; 
        }
      }

      if( this.isAtmosphera ){
      
        if ( !this.container_atmosphere_id.id ) {
          this.$vToastify.error("Campo requerido", "Error: Atmósfera Controlada");
          return false ; 
        }

        if ( !this.container_percent_o2 ) {
          this.$vToastify.error("Campo requerido", "Error: % Oxígeno (O2)");
          return false ; 
        }

        if ( !this.container_percent_co2 ) {
          this.$vToastify.error("Campo requerido", "Error: % CO2");
          return false ; 
        }
      }

      if( this.tariff_contract_id.id === null ){
        if ( !this.contract ) {
          this.$vToastify.error("Campo requerido", "Error: Nro. Contrato");
          return false ; 
        }
      }

      const valid = this.validComments();

      if( valid ){

        this.$vToastify.warning("Favor, en el campo 'Comentarios' omitir acentos y caracter 'Ñ'." , "Error" );

        return false ;
      } 

      // if ( this.bookingItineraryId !== null ) {
        
      //   if ( !this.commercialOffice ) {
      //     this.$vToastify.error("Campo requerido", "Error: Oficina Comercial");
      //     return false ; 
      //   }
      // }

      if ( this.bookingItineraryId !== null ) {
        
        if ( !this.filialOriginadora ) {
          this.$vToastify.error("Campo requerido", "Error: Filial Originadora");
          return false ; 
        }
        
        if ( !this.filialEjecutora ) {
          this.$vToastify.error("Campo requerido", "Error: Filial Ejecutora");
          return false ; 
        }
        
      }


      return true ; 
    },
    async actualizar(){
      const response = this.validar() ;

      if( !response ) return ;

      this.btnInactive = true ;

      this.$vToastify.loader("Actualizando Booking...");

      const form = this.ordenarDataActualizar() ;

      try {
        await editarBooking( form ) ;

        await this.rechargeByPage();

        this.$vToastify.stopLoader();
        
        this.closeModal() ;
        this.$vToastify.success("Booking actualizado con éxito!", "OK");
        this.btnInactive = false ;

      } catch (error) {
        this.$vToastify.stopLoader();
        this.btnInactive = false ;

        this.$vToastify.error(
          "Hubo un problema al actualizar booking, recargue y vuelva a intentar.",
          "Error: Al Actualizar Booking"
        );
      }
    },
    ordenarDataActualizar(){
      return {
        id: this.bookingId,
        year: +this.year.id ?? null,
        week: +this.week.id ?? null,
        port_load_id: +this.port_load_id.id               ?? null,
        port_origin_id: +this.port_origin_id.id           ?? null,
        port_discharge_id: +this.port_discharge_id.id     ?? null,
        port_destination_id: +this.port_destination_id.id ?? null,
        vessel: this.vessel,
        voyage: this.voyage,
        //Servicio Integral
        has_si: this.has_si.id,
        si_type_id: this.si_type_id.id ?? null,
        shipper: this.shipper.id ?? null,
        shipper_address_id: +this.shipper_address_id.id ?? null,
        shipper_consignee_id: this.shipper_consignee_id.id ?? null,
        shipper_notify_id: this.shipper_notify_id.id       ?? null,
        shipper_id: +this.shipper_id.id               ?? null,
        container_id: +this.container_id.id           ?? null,
        id_client_product: +this.id_client_product.id ?? null,
        containers_requested: +this.containers_requested,
        container_temperature:         this.container_temperature ?? null,
        container_percent_ventilation: this.container_percent_ventilation ?? null,
        container_cbm_ventilation:     this.container_cbm_ventilation     ?? null,
        container_cold_treatment: this.container_cold_treatment.id   ?? null,
        container_atmosphere_id:  this.container_atmosphere_id.id ?? null,
        container_percent_o2: this.container_percent_o2 ?? null,
        container_percent_co2: this.container_percent_co2 ?? null,
        payment_method: this.payment_method.id ?? null,
        genset: this.genset.id,
        emition_bl: this.emition_bl ?? null,
        comment: this.comment ?? null,
        contrato_booking: this.contract,
        contract: this.tariff_contract_id.id,
        contract_number: this.contract ,
        booking_itinerary_id : this.bookingItineraryId ?? null,
        booking_itinerary_state_id : this.bookingItineraryStateId ?? null,
        cant : this.cant ?? null,
        embarked_containers : this.bookingItineraryStateId == 5 ? this.embarked_containers : null,
        codigo_booking : this.booking_number ?? null,
        carrier_booking_number : this.carrier_booking_number ?? null ,
        id_deposito : this.deposit_id.id ?? null,
        id_via : this.port_track_id.id ?? null,
        id_naviera_salida : this.id_naviera_salida.id ?? null ,
        modification_request : this.mode === "SOLICITUD" ? this.infoSolicitudModificacion : null ,
        itinerary_id : this.itinerary_id,
        tariff_client_id : this.getTariffClient(),
        id_filial: !this.commercialOffice ? null : (this.commercialOffice.id ?? null),
        haulage_movement_type: this.haulage_movement_type,
        filialOriginadora: this.filialOriginadora.id,
        filialEjecutora: this.filialEjecutora.id,
        filialSoporte: this.filialSoporte ? this.filialSoporte.id : null
      };
    },
    getTariffClient(){

      let tariff = null ;

      for (const data of this.tariffsData) {
        if( data.tariff_contract_id == this.tariff_contract_id.id ){
          tariff = data.tariff_client_id ;
          break ;
        }
      }
      
      return tariff ;
    },
    disabledField(){
      this.yearDisabled = true ;

      if (!this.bookingItineraryId) {
        
        this.weekDisabled = false ;
        
      }else{
        this.weekDisabled = true ;


      }


      this.id_clientDisabled = true ;
      // this.port_load_idDisabled = true ;
      // this.port_discharge_idDisabled = true ;
      this.voyageDisabled = true ;
      this.vesselDisabled = true ;
    },
    async rechargeByPage(){

      const { name } = this.$route ;

      switch ( name ) {

        case 'bookingsDeclarados': {

          if (this.flagFiltersBookings) {

            const data = await getBookingsDeclaradosFiltrados(this.currentFiltersBookings);

            this.actionSetDataDatatableBookingsDeclarados(data);

          } else {

            const { data_table } = await getBookingsDeclarados();

            this.actionSetDataDatatableBookingsDeclarados(data_table);

          }

        }
        break;

        case 'verBookingPorAceptar': {

          if (this.flagFiltersBookings) {

            const data = await getVerMisBookingsPorAceptarFiltrados(this.currentFiltersBookings);

            this.actionSetDatatableVerMisBookingsPorAceptar(data);

          } else {

            const { data_table } = await getVerMisBookingsPorAceptar();

            this.actionSetDatatableVerMisBookingsPorAceptar(data_table);

          }

        }
        break;

        case "bookingsConfirmados": {

          if (this.flagFiltersBookings) {

            const data = await getBookingsConfirmadosClienteFiltrados(this.currentFiltersBookings);

            this.actionSetDatatableBookingsConfirmados(data);

          } else {

            const { data_table } = await getBookingsConfirmadosCliente();

            this.actionSetDatatableBookingsConfirmados(data_table);

          }

        }
        break;

        case 'bookingsEmbarcados': {

          if (this.flagFiltersBookings) {

            const data = await getBookingsEmbarcadosFiltrados(this.currentFiltersBookings);

            this.actionSetDataDatatableBookingsEmbarcados(data);

          } else {

            const { data_table } = await getBookingsEmbarcados();

            this.actionSetDataDatatableBookingsEmbarcados(data_table);

          }

        }
        break;

        case 'solicitudesModificacion': {

          if (this.flagFiltersBookings) {

            const data = await getBookingsSolicitudesModificacionFiltradas(this.currentFiltersBookings);

            this.actionSetDatatableBookingsSolicitudesModificacion(data);

          } else {

            const { data_table } = await getBookingsSolicitudesModificacion();

            this.actionSetDatatableBookingsSolicitudesModificacion(data_table);

          }

          this.actionSetVisibleModalInformacionGeneral(false) ;
        }
        break;

        default : break;
      }

      this.actionSetStateIdDeclarados( null );

    },
    async showServices(){

      this.loadingChangeService = true ; 
      this.actionSetVisibleModalCambiarServicioConfirmadoBooking(true) ;

      this.form = {
        id_booking : this.idBooking,
        booking_itinerary_id : this.bookingItineraryId
      } ;

      this.loadingChangeService = false;
    },
    validComments(){

      const reg = /ñ|Ñ|á|Á|é|É|í|Í|ó|Ó|ú|Ú/g ;

      return reg.test( this.comment );
    },
    clearCharactersTemperature(){

      let value = this.container_temperature + "" ;

      const reg = /[a-z]|[A-Z]/g ;

      value = value.trim() ;
      value = value.replaceAll( reg , "") ;
      value = value.replaceAll(',' , '.') ;

      const lastCharNoPermitidos = ['+','-',',','.'] ;
      const firstCharNoPermitidos = ['+',',','.'] ;

      let firstchar = value.charAt(0) ;
      let lastchar = value.charAt(value.length - 1) ;

      if( firstCharNoPermitidos.includes( firstchar ) ) value = value.slice(1) ;

      if( lastCharNoPermitidos.includes( lastchar ) ) value = value.slice(0,-1) ;

      this.container_temperature = value ;
    },
    async obtenerRefigeracionProductoSeleccionado() {

      const data = await obtenerRefigeracionProducto( this.id_client_product.id );

      if ( data.length > 0) {
        this.container_temperature         = data[0].temp ;
        this.container_percent_ventilation = data[0].vent;
        this.container_cbm_ventilation     = data[0].vent_cbm;
      }
    },
  },
  created(){
    this.filtrosBase() ;
  },
  watch: {
    //Flujo para asignación de datos para Booking
    stateIdDeclarados: async function( _new ){

      if( _new ){
        this.load = true ;
        await this.setDataBooking( _new ) ;
        await this.informacionDeRuta() ;
        this.load = false ;
      }
    },
    //Flujo para asignación de datos para Booking Itinerary
    idBookingItinerary: async function( _new ){

      if( _new ){
        this.load = true ;
        await this.setDataBookingItinerary( _new ) ;
        await this.informacionDeRuta() ;
        this.load = false ;
      }
    },
    dataNaveSeleccionada : function( _new ){

      if( _new ){
        this.vessel = _new.nave  ;
        this.voyage = _new.viaje ;
        this.itinerary_id = + _new.itinerary_id ;

        this.port_load_id = {
          id   : _new.pol.id.toString(),
          name : _new.pol.name 
        } ;
        
        this.navieraId = _new.naviera.id ;
        this.polEtd    = _new.from_date  ;

        this.obtenerContratos() ;
      }
    },
    
    filialSoporte(newVal) {
      if (newVal === "NONE") {
        this.filialSoporte = null;
      }
    }

  }
}
</script>

<style>

#bookingForm .mx-input {
  padding-left: 2px !important;
  border-radius: 0px !important;
  border: none !important;
  border-bottom: 1px solid #dcdcdc !important;
  box-shadow: none !important;
}

#bookingForm .mx-datepicker {
  margin-top: -3px;
  width: 100%;
}

#bookingForm .color-primary {
  color: rgba(0, 0, 0, 0.54) ;
}

</style>